import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { LANGUAGES, useT } from "@/lib/i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div ref={ref} className="relative">
      <button
        data-testid={compact ? "lang-switcher-btn-mobile" : "lang-switcher-btn-desktop"}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
        className={`inline-flex items-center gap-2 rounded-full border border-[color:var(--zp-border)] bg-white/80 backdrop-blur px-3 py-2 text-sm font-medium text-[color:var(--zp-navy)] hover:border-[color:var(--zp-cyan-2)] transition ${compact ? "" : "min-w-[7.5rem]"}`}
      >
        <Globe size={14} className="text-[color:var(--zp-cyan-3)]" />
        <span aria-hidden>{current.flag}</span>
        <span className="hidden sm:inline">{current.label}</span>
        <ChevronDown size={14} className={`transition ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <ul
          role="listbox"
          data-testid="lang-switcher-menu"
          className="absolute right-0 mt-2 w-44 rounded-2xl border border-[color:var(--zp-border)] bg-white shadow-xl overflow-hidden z-50"
        >
          {LANGUAGES.map((l) => (
            <li key={l.code}>
              <button
                data-testid={`lang-option-${l.code}`}
                role="option"
                aria-selected={l.code === lang}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-2.5 hover:bg-[color:var(--zp-bg)] ${
                  l.code === lang ? "bg-[color:var(--zp-bg-2)] font-semibold text-[color:var(--zp-navy)]" : "text-[color:var(--zp-text-2)]"
                }`}
              >
                <span aria-hidden className="text-base">{l.flag}</span>
                <span>{l.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
